<template>
  <div class="bodys" v-if="body_show">
    <div class="or_main">
      <div class="course clearfix">
        <img :src="data.promotionimg" alt="" />
        <div class="course_fg">
          <h3>{{data.coursename}}</h3>
          <h3>{{data.subname}}</h3>
          <h4>{{data.begin_time}}</h4>
        </div>
      </div>
    </div>
    <div class="or_main">
      <h2>
          <b>选择调整期次</b>
      </h2>
      <div class="mev clearfix">
        <van-radio-group class="radio_group" :class="item.selected?'radio_group_over':''" v-for="(item,index) in list" :key="index" v-model="radio" :disabled="item.selected">
          <van-radio :name="item.id">
            {{item.begin_time}} {{item.id==0?'':'开课'}}
          </van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="into_project" v-if="radio!=null" @click="setSwaps">提交</div>
    <div class="into_project into_projectover" v-else>提交</div>
  </div>
</template>
<script>
import {
  mc_getSwaps,
  mc_setSwaps
} from "@/api/person"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        list: [],
        id: null,
        alert_show: false,
        assistant_show: false,
        time: null,
        sin: null,
        radio: null
      };
    },
    methods: {
      pullData() {
        this.id = this.$route.query.id;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        mc_getSwaps({
          id: this.id
        }).then(data => {
          if (data.code == 10002) {
            this.$toast.clear();
            this.$toast(data.data.msg);
          } else {
            this.data = data;
            this.$toast.clear();
            this.body_show = true;
            // data.list[data.list.length] = {
            //   id: 0,
            //   begin_time: '待定',
            //   selected: data.undetermined?true:false
            // };
            this.list = data.list;
            shareCon("index", this);
          }
        });
      },
      setSwaps() {
        mc_setSwaps({
          id: this.id,
          cid: this.radio,
        }).then(data => {
          if (data.code == 10002) {
            this.$toast.clear();
            this.$toast(data.data.msg);
          } else {
            this.$toast.clear();
            this.$router.push({
              path: '/my_course_details',
              query: {
                'id': data.id
              }
            })
          }

        });
      },
    },
    created() {
      this.pullData();
    }
};
</script>
<style lang="scss" scoped>
.or_t {
  text-align: center;
  padding: 30px 0;
  img {
    width: 94px;
  }
  p {
    font-size: 34px;
    color: #333;
    margin-top: 20px;
  }
  h5 {
    color: #999;
    font-size: 24px;
  }
}

.or_main {
  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 16px;
  h2 {
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
    color: #333;
    font-size: 28px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      color: #333;
      img {
        display: inline-block;
        width: 26px;
        vertical-align: inherit;
        margin-left: 10px;
      }
    }
    b {
      width: 320px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: normal;
      display: inline-block;
    }
  }
  .course {
    display: block;
    margin-top: 20px;
    position: relative;
    .course_fg {
      float: left;
      margin-left: 20px;
      h3 {
        color: #333;
        font-size: 26px;
      }
      h4 {
        color: #999;
        font-size: 24px;
        margin-top: 0;
      }
    }
    img {
      width: 200px;
      float: left;
    }
    span.sp1 {
      color: #333;
      font-size: 26px;
      float: right;
    }
  }
  .courses {
    border-bottom: 2px solid #ccc;
    padding-bottom: 30px;
  }
  ul.vr {
    li {
      color: #333;
      font-size: 26px;
      line-height: 48px;
      margin-top: 30px;
      span {
        color: #999;
        font-size: 20px;
        margin-left: 10px;
      }
      a {
        width: 134px;
        height: 48px;
        background-color: #EB5032;
        color: #fff;
        border-radius: 24px;
        font-size: 24px;
        line-height: 48px;
        text-align: center;
        margin-left: 10px;
        display: inline-block;
        float: right;
      }
      .over {
        background-color: #CCCCCC;
        border-color: #CCCCCC;
        color: #fff;
      }
      .cf {
        border: 2px solid rgba(235, 80, 50, 1);
        color: #EB5032;
        background-color: #fff;
      }
      .ov {
        border: 2px solid #ccc;
        color: #ccc;
        background-color: #fff;
      }
    }
  }
  h3.hegv {
    font-size: 24px;
    color: #999;
    margin-top: 20px;
    border-top: 2px solid #ccc;
    padding-top: 30px;
    img {
      display: inline-block;
      width: 26px;
      vertical-align: inherit;
      margin-left: 10px;
      float: right;
    }
    .kef {
      margin-right: 15px;
      margin-left: 0;
      float: none;
    }
  }
  h4 {
    font-size: 24px;
    color: #999;
    margin-top: 20px;
  }
}

.into_project {
  background: #EB5032;
  width: 100%;
  max-width: 750px;
  line-height: 98px;
  height: 98px;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: 34px;
  color: #fff;
}

.into_projectover {
  background-color: #ccc;
}

.confirm_box h2 {
  padding: 25px 20px;
  padding-bottom: 10px
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box .btn_group a.cancel {
  width: 100%;
  color: #EB5032
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 105px 85px 84px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 20px;
    }
  }
}

.rk {
  margin-top: 30px;
  text-align: right;
  a {
    width: 134px;
    height: 48px;
    background-color: #EB5032;
    color: #fff;
    border-radius: 24px;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    margin-left: 10px;
    display: inline-block;
  }
  .over {
    background-color: #CCCCCC;
    border-color: #CCCCCC;
    color: #fff;
  }
  .cf {
    border: 2px solid rgba(235, 80, 50, 1);
    color: #EB5032;
    background-color: #fff;
  }
  .ov {
    border: 2px solid #ccc;
    color: #ccc;
    background-color: #fff;
  }
}
</style>
<style>
.mev {
  margin-top: 0
}

.mev .radio_group {
  margin-top: 30px;
  width: 300px;
  line-height: 70px;
  text-align: center;
  color: #EB5032;
  font-size: 26px;
  border: 2px solid rgba(235, 80, 50, 1);
  float: left;
  position: relative;
}

.mev .radio_group:nth-child(even) {
  float: right;
}

.mev .radio_group_over {
  color: #999999;
  border-color: #ccc
}

.mev .radio_group:last-child {
  margin-bottom: 0;
}

.mev .radio_group .van-radio {
  /* width: 100%;
  position: relative;*/
}

.mev .radio_group .van-radio .van-radio__icon {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 36px;
  line-height: 36px;
}

.mev .radio_group .van-radio .van-radio__icon .van-icon {
  border: none;
  background: none;
}

.mev .radio_group .van-radio .van-radio__icon .van-icon:before {
  content: '';
}

.radio_group .van-radio .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  width: 43px;
  height: 36px;
  background-image: url(../../../assets/radio_dw.png);
  background-size: cover;
  border-radius: 0;
  transition: .03s;
}

.mev .radio_group .van-radio__label {
  line-height: 100%;
  text-align: center;
  color: #EB5032;
  margin-left: 0;
  font-size: 26px;
}

.mev .radio_group_over .van-radio__label {
  color: #999
}
</style>
